import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const setToken = (t) => {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  };

  const refreshUser = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setUser(null); setLoading(false); return null; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setToken(null);
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.pathname.startsWith("/auth/google")) { setLoading(false); return; }
    refreshUser();
  }, [refreshUser]);

  const applyAuth = (data) => {
    setToken(data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    return applyAuth(data);
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return data;
  };
  const verifyOtp = async (email, otp) => {
    const { data } = await api.post("/auth/verify-email-otp", { email, otp });
    return applyAuth(data);
  };
  const mobileSignup = async (mobile, name, role) => {
    const { data } = await api.post("/auth/mobile/signup", { mobile, name, role });
    return data;
  };
  const mobileVerify = async (mobile, otp) => {
    const { data } = await api.post("/auth/mobile/verify", { mobile, otp });
    return applyAuth(data);
  };
  const msg91Verify = async (access_token) => {
    const { data } = await api.post("/auth/msg91/verify", { access_token });
    return applyAuth(data);
  };
  const googleExchange = async (code, redirect_uri, role) => {
    const { data } = await api.post("/auth/google", { code, redirect_uri, role: role || null });
    return applyAuth(data);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, register, verifyOtp, mobileSignup, mobileVerify, msg91Verify, googleExchange, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
